<template>
  <v-form v-bind="this.$attrs">
    <div class="wrap_filter">
      <v-row class="mb-0">
        <v-col cols="12" md="3" class="pb-0">
          <v-text-field v-model="name" label="Tên câu lạc bộ" outlined required dense hide-details> </v-text-field>
        </v-col>
        <v-col class="d-flex align-center justify-end pb-0" cols="12" md="9">
          <div>
            <v-btn class="search-button" height="40" outlined @click="filter"> Tìm kiếm </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  components: {},
  data() {
    return {}
  },

  computed: {},
  created() {
    this.fetch({ _limit: 10, _start: 0 })
    this.count({})
  },
  methods: {
    ...mapActions({
      fetch: 'club/fetch',
      count: 'club/count'
    }),
    ...mapMutations({
      setState: 'club/setState'
    }),
    async filter() {
      try {
        this.setState({ atr: 'loading', value: true })
        const params = {
          name_contains: this.name
        }
        await this.fetch({ ...params, _limit: 10, _start: 0 })
        await this.count(params)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setState({ atr: 'loading', value: false })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 960px) {
  .wrap_filter {
    display: block;
  }
}
</style>
